// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-message-box .el-message-box__btns .el-button.el-button--default[data-v-0b061734]:focus,.el-message-box .el-message-box__btns .el-button.el-button--default[data-v-0b061734]:hover{color:#15a675;background:#fff;border-color:#15a675}.el-message-box .el-message-box__btns .el-button.el-button--default.el-button--primary[data-v-0b061734],.el-message-box .el-message-box__btns .el-button.el-button--primary[data-v-0b061734]{color:#fff;background:#b60005;border-color:#b60005}", ""]);
// Exports
module.exports = exports;
